<script lang="ts" setup>
/**
 * @deprecated Use ElTabGroup instead
 */
import ElTab from '@/ElTab.vue';

const props = defineProps<{
  modelValue: string;
  tabs: {
    label: string;
    disabled?: boolean;
  }[];
}>();

const emit = defineEmits<{
  (event: 'update:modelValue', modelValue: string): void;
}>();

const onClick = (tab: string) => {
  emit('update:modelValue', tab);
};

const getTabStatus = (tab: { label: string; disabled?: boolean }) => {
  if (tab.disabled) return 'inactive';
  if (tab.label === props.modelValue) return 'active';
  return 'default';
};
</script>

<template>
  <div class="inline-block">
    <div class="flex">
      <ElTab
        v-for="(tab, index) in tabs"
        :key="`tab-${index}`"
        class="grow"
        :label="tab.label"
        :status="getTabStatus(tab)"
        @click="onClick(tab.label)"
      ></ElTab>
    </div>
  </div>
</template>
